'use client';

import { useEffect } from 'react';
import { GA4Tracker } from '@weberus/client-tracker';
import useRegisterIsPcWidth from '@/app/_shared/hooks/use-register-is-pc-width';

interface ClientInitializerProps {
  headers?: Headers;
}

export default function ClientInitializer(_props: ClientInitializerProps) {
  useEffect(() => {
    GA4Tracker.initialize({ gaApiKey: process.env.NEXT_PUBLIC_GA_ID });
  }, []);

  useRegisterIsPcWidth();
  return null;
}
